import styled from "@emotion/styled"

const StyledCategorySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
  }

  .actions .MuiButton-root {
    text-transform: none;
    font-weight: 700;
    border-radius: 11px;
    box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);
    padding: 8px 14px;
  }

  .category-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
  }

  .category-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    border: 1px dashed var(--cms-border);
    border-radius: 14px;
    font-size: 14px;
    font-weight: 600;
    color: var(--cms-text-secondary);
    background: var(--cms-surface-muted);
  }

  .sub-category-table {
    border-radius: 12px;
    border: 1px solid var(--cms-border);
    overflow: hidden;
  }
`

const CategoryWrapper = styled.div`
  .category-list {
    display: flex;
  }

  .category {
    margin: 10px;
    padding: 20px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    div {
      margin-bottom: 10px;
    }
    .media {
      height: 150px;
      border: 1px dashed var(--cms-border);
      padding: 0 30px;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-top: 20px;
      color: var(--cms-text-secondary);
      &:hover {
        background-color: var(--cms-hover-bg);
      }
    }
  }
`

const StyledCategoryItem = styled.div`
  margin: 6px 0;

  .MuiAccordion-root {
    border: 1px solid var(--cms-border);
    border-radius: 14px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
    overflow: hidden;
  }

  .MuiAccordion-root::before {
    display: none;
  }

  .MuiAccordionSummary-root {
    min-height: 72px;
    padding: 6px 16px;
    border-bottom: 1px solid transparent;
  }

  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 72px;
    border-bottom-color: var(--cms-border);
  }

  .MuiAccordionSummary-content {
    align-items: center;
    margin: 12px 0;
  }

  .MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0;
  }

  .category-summary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    width: 100%;
  }

  .category-id-chip {
    min-width: 125px;
  }

  .category-name {
    font-size: 15px;
    font-weight: 700;
    color: var(--cms-text-primary);
  }

  .category-fullname-chip {
    margin-left: auto;
    max-width: min(50%, 420px);
  }

  .category-status-chip {
    margin-left: auto;
  }

  .category-fullname-chip + .category-status-chip {
    margin-left: 0;
  }

  .MuiChip-root {
    font-size: 12px;
  }

  .MuiAccordionDetails-root {
    padding: 16px;
    background: var(--cms-surface-muted);
  }

  .action-bar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 9px;
    flex-wrap: wrap;
    margin: 0 0 14px;
  }

  .action-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    box-shadow: none;
  }

  .action-btn.reorder {
    background: linear-gradient(170deg, #4f46e5 0%, #4338ca 100%);
  }

  .action-btn.add {
    background: linear-gradient(170deg, #0284c7 0%, #0369a1 100%);
  }

  .action-btn.order {
    background: linear-gradient(170deg, #f59e0b 0%, #d97706 100%);
  }

  .action-btn.edit {
    background: linear-gradient(170deg, #0ea5a4 0%, #0f766e 100%);
  }

  .action-btn.show {
    background: linear-gradient(170deg, #22c55e 0%, #16a34a 100%);
  }

  .action-btn.hide {
    background: linear-gradient(170deg, #64748b 0%, #475569 100%);
  }

  .action-btn.delete {
    background: linear-gradient(170deg, #ef4444 0%, #dc2626 100%);
  }

  .subcategory-table {
    border-radius: 12px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-secondary);
    overflow: hidden;
  }

  .subcategory-table .MuiTableCell-head {
    background: var(--cms-table-head-bg);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
  }

  .subcategory-table .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
  }

  .subcategory-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }

  .empty-subcategory-title {
    margin: 0 0 6px;
    font-size: 15px;
    font-weight: 700;
    color: var(--cms-text-primary);
  }

  .empty-subcategory {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
  }
`

const StyledCategoryProgramItem = styled.div`
  display: flex;
  border-radius: 14px;
  margin: 6px 0 14px;
  font-size: 14px;
  padding: 16px;
  border: 1px solid var(--cms-border);
  background: var(--cms-surface-secondary);
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.07);
  align-items: flex-start;
  gap: 16px;

  .thumbnail {
    width: 170px;
    flex-shrink: 0;
    img {
      width: 100%;
      max-height: 96px;
      object-fit: cover;
      border: 1px solid var(--cms-border);
      border-radius: 9px;
    }
  }

  .info {
    width: 100%;
    .identity {
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color: var(--cms-text-secondary);
    }
    .title {
      font-size: 15px;
      font-weight: 700;
      margin: 6px 0;
      color: var(--cms-text-primary);
    }
    .desc {
      font-size: 13px;
      line-height: 1.45;
      color: var(--cms-text-secondary);
      white-space: pre-wrap;
      word-break: break-word;
    }
  }
`
export {
  StyledCategorySection,
  CategoryWrapper,
  StyledCategoryItem,
  StyledCategoryProgramItem,
}
